import Vue from 'vue';
import Router from 'vue-router';


Vue.use(Router);


// 静态路由,这里写好一些不需要从后台获取的路由,如首页,404页面
export const constantRoutes = [
	{
		path: '/',
		redirect: '/login'
	},
	{
		path: '/login',
		component: () => import( /* webpackChunkName: "login" */ '@/components/page/Login.vue'),
		meta: {
			title: '登录'
		}
	},
	{
		path: '/substituteDrivingDispatch',
		component: () => import( /* webpackChunkName: "gdmap" */ '@/components/page/orderManagement/substituteDrivingDispatch.vue'),
		meta: {
			title: '代驾订单'
		}
	},
	{
		path: '/driverAll',
		component: () => import( /* webpackChunkName: "city" */ '@/components/page/orderManagement/driverAll.vue'),
		meta: {
			title: '司机调度'
		}
	}
];


const createRouter = () => new Router({
	scrollBehavior: () => ({ y: 0 }),
	routes: constantRoutes
});

const router = createRouter();

// 重置路由
export function resetRouter() {
	const newRouter = createRouter();
	router.matcher = newRouter.matcher; // reset router
}

export default router;
